<script>
  import { blogs, blogsUpdated } from "./constants";
  import List from "./List.svelte";
</script>

<h3 class="m-0 text-sm transition-all top-7 right-7 tracking-widest absolute group-hover:text-true-gray-50">更新于 {blogsUpdated}</h3>

<List items={blogs} name="blog" />
